import {
  fraudStatusDetailsQuery,
  DeviceFraudStatusIcon,
} from "./DeviceFraudStatusIcon";
import FraudStatusIcon from "./FraudStatusIcon";
import LinkUsersAndDevicesTable, {
  fragments as linkUsersAndDevicesTableFragments,
} from "./LinkedUsersAndDevicesTable";
import DeviceFraudComments from "./DeviceFraudComments";
import { fragments as deviceFraudCommentsFragments } from "./Fragment.FraudCommentsParts";

const fragments = {
  ...linkUsersAndDevicesTableFragments,
  ...deviceFraudCommentsFragments,
};

export {
  fraudStatusDetailsQuery,
  FraudStatusIcon,
  DeviceFraudStatusIcon,
  LinkUsersAndDevicesTable,
  DeviceFraudComments,
  fragments,
};
